document.addEventListener("DOMContentLoaded", function () {
  // Journey Slider Functionality
  const journeySlider = document.querySelector(".journey-slider-container");
  if (!journeySlider) return;

  const slidesContainer = journeySlider.querySelector(
    ".journey-slides-container"
  );
  const slides = journeySlider.querySelectorAll(".journey-slide");
  const dots = journeySlider.querySelectorAll(".journey-slider-dot");
  const prevBtn = journeySlider.querySelector(".journey-slider-prev");
  const nextBtn = journeySlider.querySelector(".journey-slider-next");

  let currentSlide = 0;
  const totalSlides = slides.length;

  // Initialize slider
  function initSlider() {
    updateSlider();
    updateDots();
  }

  // Update slider position and active states
  function updateSlider() {
    // Calculate transform value based on current slide
    const transformValue = -(currentSlide * 33.333);
    slidesContainer.style.transform = `translateX(${transformValue}%)`;
  }

  // Update pagination dots
  function updateDots() {
    dots.forEach((dot, index) => {
      dot.classList.toggle("active", index === currentSlide);
    });
  }

  // Go to specific slide
  function goToSlide(slideIndex) {
    currentSlide = slideIndex;
    updateSlider();
    updateDots();
  }

  // Next slide
  function nextSlide() {
    currentSlide = (currentSlide + 1) % totalSlides;
    updateSlider();
    updateDots();
  }

  // Previous slide
  function prevSlide() {
    currentSlide = (currentSlide - 1 + totalSlides) % totalSlides;
    updateSlider();
    updateDots();
  }

  // Event listeners
  if (prevBtn) {
    prevBtn.addEventListener("click", prevSlide);
  }

  if (nextBtn) {
    nextBtn.addEventListener("click", nextSlide);
  }

  dots.forEach((dot, index) => {
    dot.addEventListener("click", () => goToSlide(index));
  });

  // Touch/swipe support
  let startX = 0;
  let endX = 0;

  journeySlider.addEventListener("touchstart", (e) => {
    startX = e.touches[0].clientX;
  });

  journeySlider.addEventListener("touchend", (e) => {
    endX = e.changedTouches[0].clientX;
    handleSwipe();
  });

  function handleSwipe() {
    const swipeThreshold = 50;
    const diff = startX - endX;

    if (Math.abs(diff) > swipeThreshold) {
      if (diff > 0) {
        // Swipe left - next slide
        nextSlide();
      } else {
        // Swipe right - previous slide
        prevSlide();
      }
    }
  }

  // Initialize the slider
  initSlider();
});
